<mat-sidenav-container>
    <mat-sidenav-content>
        <form id="container" [formGroup]="formActualizacion" [style.fontSize.px]="16" (ngSubmit)="cambiar()">
            <mat-card appearance="outlined" class="mat-elevation-z8">
                <div class="row gx-0">

                    <div id="container-login">
                        <mat-card-title>
                            <img class="responsive" [src]="logos" src="" alt="" />
                        </mat-card-title>
                        <mat-divider class="d-lg-none" inset></mat-divider>
                        <mat-card-title>
                            <h3>Actualizar contraseña olvidada</h3>
                        </mat-card-title>
                        <mat-card-content>
                            <p class="text-center">La contraseña debería tener al menos 8 caracteres, máximo 15
                                caracteres, al menos 1 dígito, al menos 1
                                minúscula, al menos 1 MAYÚSCULA.</p>
                            <mat-form-field>
                                <mat-label>Nueva Contraseña</mat-label>
                                <input placeholder="NUEVA CONTRASEÑA" matInput formControlName="newPassword"
                                    [type]="hide ? 'password' : 'text'" />
                                <button type="button" mat-icon-button matSuffix (click)="hide = !hide">
                                    <mat-icon color="primary">{{
                                        hide
                                        ? "visibility_off"
                                        : "visibility"
                                        }}</mat-icon>
                                </button>
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Repetir Nueva Contraseña</mat-label>
                                <input placeholder="REPETIR NUEVA CONTRASEÑA" matInput
                                    formControlName="repeatedNewPassword" type="password" />
                            </mat-form-field>

                            <mat-card-actions>
                                <button class="mb-4" type="submit" mat-raised-button color="primary"
                                    [disabled]="!formActualizacion.valid">
                                    <mat-icon>update</mat-icon>
                                    <span>Cambiar</span>
                                </button>
                                <button mat-raised-button color="primary" type="button" (click)="cancelar()">
                                    <mat-icon>close</mat-icon>
                                    <span>Cancelar</span>
                                </button>
                            </mat-card-actions>
                        </mat-card-content>
                    </div>

                </div>
            </mat-card>
            <!-- <ng-template #other>
                <div *ngIf="mobile" class="padding">
                    <img class="responsive" [src]="logos" src="" alt="" />
                    <br />
                    <br />
                    <h3>Actualizar contraseña olvidada</h3>
                    <br />
                    <mat-form-field>
                        <mat-label>Nueva Contraseña</mat-label>
                        <input
                            placeholder="Nueva Actual"
                            matInput
                            formControlName="newPassword"
                            [type]="hide ? 'password' : 'text'"
                        />
                        <button
                            type="button"
                            mat-icon-button
                            matSuffix
                            (click)="hide = !hide"
                        >
                            <mat-icon color="primary">{{
                                hide ? "visibility_off" : "visibility"
                            }}</mat-icon>
                        </button>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Repetir Nueva Contraseña</mat-label>
                        <input
                            placeholder="Repetir Nueva Contraseña"
                            matInput
                            formControlName="repeatedNewPassword"
                            type="password"
                            (change)="cancelar()"
                        />
                    </mat-form-field>

                    <br />
                    <br />

                    <button
                        class="mb-4"
                        type="submit"
                        mat-raised-button
                        color="primary"
                        [disabled]="!formActualizacion.valid"
                    >
                        <mat-icon>update</mat-icon> <span>Cambiar</span>
                    </button>
                    <button
                        mat-raised-button
                        color="primary"
                        [disabled]="!formActualizacion.valid"
                        type="submit"
                        (click)="cancelar()"
                    >
                        <mat-icon>exit</mat-icon> <span>Iniciar Sesión</span>
                    </button>
                </div>
            </ng-template> -->
        </form>
    </mat-sidenav-content>
</mat-sidenav-container>

<!-- <div class="img-he" style="display:flex; justify-content: center; align-items: center ; padding: 10px" >
     <img [src]="logos" alt="logo-itt">
</div>

<mat-label>
    <h1>Actualización de Contraseña Olvidada</h1>
</mat-label> -->
